import { FormDateField } from "@pharmupp/p3-front-commons"
import { fields } from "../../GeneralInfos.fields"
import { isBirthDateRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

export const ConditionalBirthDateField = () => {
  const type = useGetUserTypeField()

  const required = isBirthDateRequired(type)

  return (
    <FormDateField
      label="Date de naissance"
      name={fields.birthDate}
      sx={{ width: "100%" }}
      required={required}
    />
  )
}
